import axios from "axios";
import Cookies from "universal-cookie";

// I made this so you only have to add the endpoint for each request and that you dont have to always get the token.
// How to use it:
// Just do loyalty.method('endpoint') its almost the same as axios but you dont have to put the baseUrl in every request.

const cookies = new Cookies();

const loyalty = axios.create({
  baseURL: 'https://loyalty.techdogcloud.com/api/',
});

try {
  loyalty.interceptors.request.use(config => {
    const token = cookies.get('token');
    if (token) {
      config.headers.ApiKey = token; // Adds the header to the request if it exists.
    }
    return config;
  });  
} catch (error) {
  console.error(`Unkown error:`, error);
}


export default loyalty;